import classNames from 'classnames';
import {components, DropdownIndicatorProps} from 'react-select';
import {memo, ReactNode} from 'react';
import Icon from 'components/Icon';
import style from '../style.module.scss';

interface IProps {
    dropDownIndicatorIcon?: ReactNode;
}

export const DropdownIndicator = memo<IProps & DropdownIndicatorProps>(({dropDownIndicatorIcon, ...props}) => {
    const {
        selectProps: {menuIsOpen},
        isDisabled,
    } = props;

    return (
        <components.DropdownIndicator {...props}>
            {
                <button className={style.inputSelectDropDown} disabled={isDisabled} type={'button'}>
                    <div
                        className={classNames(style.inputSelectDropDownIcon, {
                            [style.inputSelectDropDownRotate]: menuIsOpen,
                        })}
                    >
                        {dropDownIndicatorIcon || <Icon className={style.commonIcon} icon={'down'} />}
                    </div>
                </button>
            }
        </components.DropdownIndicator>
    );
});
